import { LaundryMachineOption, LaundryTypeOption, PaymentOption } from "../../types/laundry.types";
import { LaundryStoreInteraction, PAGES, PAYMENT_TYPES, TotemLaundryStoreState } from "./LaundryStore.types";

export const paymentOptions: PaymentOption[] = [
  {
    type: PAYMENT_TYPES.CARD_DEBIT,
    title: "Cartão de Débito",
  },
  {
    type: PAYMENT_TYPES.CARD_CREDIT,
    title: "Cartão de Crédito",
  },
];

// Mocks

export const mockOptions: LaundryTypeOption[] = [
  {
    id: "teste",
    type: "L12",
    name: "Lavanderia Básica",
    price: 10.00,
    stations: [],
    estimatedTime: 60,
  },
  {
    id: "teste",
    type: "S12",
    name: "Lavanderia Básica 2",
    price: 15.00,
    stations: [],
    estimatedTime: 45,
  },
];

export const defaultWashing = {
  id: "teste",
  type: "L12",
  name: "Lavagem Básica",
  price: 10.00,
}

export const laundryStoreInteraction: LaundryStoreInteraction = {
  currPage: PAGES.START_PAGE,
  selectedLaundryType: {} as LaundryTypeOption,
  selectedPayment: {} as any,
  errorMsg: "",
  finalPrice: 0,
  paymentId: "",
  cieloTransactionId: "",
  taxId: "",
  selectedLaundryMachine: {} as LaundryMachineOption,
}

export const laundryStoreState: TotemLaundryStoreState = {
  ...laundryStoreInteraction,
  laundryTypeOptions: [],
  laundryMachineOptions: [],
  totemId: "",
  terminalId: "",
};
